import { BoxxOAuthResponseProps } from './IBoxxOAuth';

export interface IFacebookPluginOAuthResponse {
  authResponse: {
    accessToken: string;
    data_access_expiration_time?: string;
    expiresIn?: string;
    userID?: string;
  };
  status?: string;
}

export interface IFacebookOAuthResponse extends BoxxOAuthResponseProps {
  profileResponse: {
    email: string;
    firstName: string;
    lastName: string;
  };
  authResponse: {
    accessToken: string;
    data_access_expiration_time?: string;
    expiresIn?: string;
    userID?: string;
  };
  status?: string;
  pages?: any;
}
